module.exports = __webpack_public_path__ + "img/simple.3226a883.svg";